import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Tooltip,
  useMediaQuery,
  useTheme,
} from "@mui/material";
//import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { FC, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { IRootReducer } from "../../../../reducers";
import { createAgencyRequest } from "../../../../actions";
import AgencyForm, { AgencyFormHandle, AgencyFormMode } from "../agency-form";
import { AgencyAdminStoreSuccess, AgencyAdminStoreError } from "../../../../enums/store-messages/admin";

interface CreateAgencyProps {
}

const CreateAgencyModal: FC<CreateAgencyProps> = (props) => {
  const dispatch = useDispatch();
  const store = useSelector((state: IRootReducer) => state.agencyReducer);
  const formRef = useRef<AgencyFormHandle>(null);

  // UI control
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const [isOpen, setIsOpen] = useState(false);
  const [isValid, setIsValid] = useState(false);

  const handleOpen = () => {
    setIsOpen(true);
  };

  const handleCancel = (event?: object, reason?: string) => {
    if (reason === "backdropClick") return false;
    setIsOpen(false);
    formRef.current?.reset();
  };

  const handleSubmit = () => {
    if (formRef.current) {
      setIsValid(false); // prevent submitting again
      const agency = formRef.current?.getValues();
      dispatch(createAgencyRequest(agency));
    }
  };

  useEffect(() => {
    if (store.successMessage === AgencyAdminStoreSuccess.CREATE_AGENCY_SUCCESS) {
      formRef.current?.reset();
      setIsOpen(false);
    } else if (store.failureMessage === AgencyAdminStoreError.CREATE_AGENCY_ERROR) {
      setIsValid(true); // allow submitting again
    }
  }, [store.successMessage, store.failureMessage]);

  const handleValidityChanged = (newValue: boolean) => {
    setIsValid(newValue);
  }

  return (
    <>
      <Tooltip title="Add a new agency to the VCC">
        <Button
          variant="contained"
          color="primary"
          onClick={handleOpen}
          style={{ minWidth: "150px", color: "white" }}
        >
          Add Agency
        </Button>
      </Tooltip>

      <Dialog
        fullScreen={fullScreen}
        fullWidth
        open={isOpen}
        onClose={handleCancel}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">Add Agency</DialogTitle>
        <DialogContent className="create-edit-agency">
          <DialogContentText>
            Enter required information to add an agency to the VCC
          </DialogContentText>
          <AgencyForm ref={formRef} mode={AgencyFormMode.CREATE} onValidityChanged={handleValidityChanged} />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancel} color="inherit" variant="contained">
            Cancel
          </Button>
          <Button
            disabled={!isValid}
            onClick={handleSubmit}
            color="primary"
            variant="contained"
          >
            Add Agency
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default CreateAgencyModal;
